<div class="slidepop" [ngClass]="{'open': showSidePanel}">
  
  <div class="slidecontent">

   <div *ngIf="showcreateForm">
      <app-create-users *ngIf="showcreateForm" (closeSidePanel)="closeSidePanel($event)" (closeSidePanelAfterSave)="closeSidePanelAfterSave($event)"
       [ngClass]="{ open: showcreateForm }"> </app-create-users>
    </div>

    <div *ngIf="showeditForm">
      <app-edit-users *ngIf="showeditForm" (closeSidePanel)="closeSidePanel($event)" (closeSidePanelAfterSave)="closeSidePanelAfterSave($event)"
       [ngClass]="{ open: showeditForm }"> </app-edit-users>
    </div>
  
  </div>   
</div>
<!-- <app-edit-users (getcloseCreateRole)="closeSidePanel($event)" [ngClass]="{ open: showeditForm }"></app-edit-users>

<app-create-users (getcloseCreateRole)="closeSidePanel($event)" [ngClass]="{ open: showcreateForm }"></app-create-users> -->


<mat-card class="filter">
  <div class="sort_layout" fxLayout="row" fxLayoutAlign="start center">
    <h3>Users</h3>


    <div *ngIf="showSuperAdmin==true" class="officeFieldsHolder">
      <mat-checkbox class="example-margin" (change)="ShowViewAll($event)">View All</mat-checkbox>
  
      <div *ngIf="showOrgOffice==true" class="officeFields" >
     
      <mat-form-field>
        <mat-select placeholder = "Select Organization"  
          (selectionChange)="getOffice($event)">
           <mat-option *ngFor = "let data of OrgnizationList" 
              [value] = "data.organizationID">
              {{data.organizationName}}
           </mat-option>
        </mat-select>
     </mat-form-field>
  
     <mat-form-field>
      <mat-select placeholder = "Select Office" (selectionChange)="selectOffice($event)">
         <mat-option *ngFor = "let data of OrgOfficeList" 
            [value] = "data.officeID">
            {{data.officeName}}
         </mat-option>
      </mat-select>
     </mat-form-field>
  
  </div>
  
    </div>

    
  </div>

 
  

  <div class="actbtn">
    <mat-slide-toggle class="mr-10" *ngIf="showToogle==true" color="primary" (change)="ShowAll($event)">All Offices Users
    </mat-slide-toggle>

    <button mat-flat-button color="primary" (click)="addUsers()">
      Add User
    </button>
  </div>

</mat-card>

  <div class="content-card">
    <app-table id="SDSAppTable"
    [downloadFileName]="'UserList'" [totalCount]="totalCount"
    [pageIndex]="pageIndex" [pageSize]="pageSize"
    [displayedColumns]="sendDisplayedColumns" [showColumnNames]="showColumnNames"
    [targetList]="userData"  [modulename]="Module" [clickableColumns]="clickableColumns"  
    (editObject)="openEditDialogData($event)" (pageChangeEvent)=CallNextPrevPageData($event)
    (exportToExcel)="exportAsXLSX()">
    </app-table>
  </div>

<!-- <app-loader></app-loader> -->


